export enum EconomicSubjectVatType {
	NotVatSubject = "NotVatSubject",
	EuSubject = "EuSubject",
	CzSubject = "CzSubject",
}
